import { isPlatform } from '@ionic/angular/standalone';
import { arrowBack, chevronBack } from 'ionicons/icons';

/**
 * Formato de la barra de título (toolbar, título y botón volver) según el equipo:
 *  - 'touch' (teléfono y tablet): formato iOS — 44px, título centrado, chevron.
 *  - 'web' (escritorio): barra más alta, título a la izquierda y flecha.
 *
 * Se decide una sola vez al arrancar (el tipo de equipo no cambia en caliente) con el mismo criterio que
 * PlatformService.isMobile()/isTablet(), para que coincida con el shell (tabs vs menú lateral).
 * Las reglas visuales viven en global.scss bajo html.gm-chrome-touch / html.gm-chrome-web.
 */
export type NavigationChrome = 'touch' | 'web';

export function resolveNavigationChrome(win: Window = window): NavigationChrome {
    const touch =
        isPlatform(win, 'mobile') ||
        isPlatform(win, 'mobileweb') ||
        isPlatform(win, 'tablet') ||
        isPlatform(win, 'ipad') ||
        /Mobi|Android|iPad|Tablet/i.test(win.navigator.userAgent);
    return touch ? 'touch' : 'web';
}

export const NAVIGATION_CHROME: NavigationChrome = resolveNavigationChrome();

/** Ícono por defecto de todos los ion-back-button de la app (config global de Ionic). */
export const BACK_BUTTON_ICON = NAVIGATION_CHROME === 'web' ? arrowBack : chevronBack;

/** Marca <html> para que global.scss aplique el formato de barra correspondiente. */
export function applyNavigationChromeClass(doc: Document = document): void {
    doc.documentElement.classList.add(`gm-chrome-${NAVIGATION_CHROME}`);
}
